import { createEvent, createStore } from 'effector';
import { SELLER_ACCOUNT_BUYERS_SORT } from '../constants';

export const setBuyersListSortOption = createEvent<
  {
    label: string;
    val: string;
    active: boolean;
  }[]
>();
export const setBuyersListSortSearchString = createEvent<string>();
export const setBuyersListOrder = createEvent<'asc' | 'desc'>();
export const $buyersListSortState = createStore<{
  options: { label: string; val: string; active: boolean }[];
  orderBy: 'asc' | 'desc';
  searchString: string;
}>({
  options: [
    { label: 'алфавиту', val: 'company_name', active: true },
    // { label: 'расстоянию от вас', val: 'distance', active: false },
    { label: 'типу контрагента', val: 'type', active: false },
  ],
  orderBy: 'asc',
  searchString: '',
});

$buyersListSortState.on(setBuyersListSortOption, (s, p) => {
  localStorage.setItem(
    SELLER_ACCOUNT_BUYERS_SORT,
    JSON.stringify({ ...s, options: p }),
  );
  return { ...s, options: p };
});
$buyersListSortState.on(setBuyersListOrder, (s, p) => {
  localStorage.setItem(
    SELLER_ACCOUNT_BUYERS_SORT,
    JSON.stringify({ ...s, orderBy: p }),
  );
  return { ...s, orderBy: p };
});
$buyersListSortState.on(setBuyersListSortSearchString, (s, p) => {
  localStorage.setItem(
    SELLER_ACCOUNT_BUYERS_SORT,
    JSON.stringify({ ...s, searchString: p }),
  );
  return { ...s, searchString: p };
});
